// extracted by mini-css-extract-plugin
module.exports = {"container":"CollapsibleContainer_container__tzY3n"};